import SaveTrasladoInventario from "../../shared/componente/save_traslado/SaveTrasladoInventario";


export default function CreateTrasladoInventarioIngresoPage() {

  return (
    <SaveTrasladoInventario
      title="📦Crear Transferencia Inventario"
    />
  )

}